<section class="relative overflow-hidden bg-cover bg-center"
  [style.backgroundImage]="'url(' + ('assets/img/tecnologias.png' | imageConverter) + ')'"
  aria-label="Sección de Tecnologías">
  <div *ngIf="showTechnologies" class="relative h-[10rem] sm:h-[12rem] overflow-hidden flex justify-center items-center"
    role="region" aria-live="polite">
    <div #scrollContainer class="scroll-track absolute flex space-x-5 md:space-x-5 lg:space-x-20">
      <div *ngFor="let logo of duplicatedLogos; trackBy: trackByLogo"
        class="logo-container flex justify-center items-center">
        <picture>
          <source [srcset]="logo.src | imageConverter" type="image/webp">
          <img [src]="logo.src" [alt]="logo.alt" role="presentation" aria-hidden="true" class="logo-img"
            loading="lazy" />
        </picture>
      </div>
    </div>
  </div>

  <div
    class="bg-[#5173EF] font-poppins text-[#F2F4FE] p-4 flex flex-col md:flex-col lg:flex-row items-center h-auto md:h-auto lg:h-[31vh]"
    id="technologies-section">
    <div class="flex-grow ml-0 md:ml-0 lg:ml-28 text-center md:text-center lg:text-left">
      <h2 class="text-lg sm:text-lg md:text-lg lg:text-xl tracking-wider font-light mb-4">{{ 'technologies.title' |
        translate }}</h2>
      <p class="text-xs sm:text-xs md:text-xs lg:text-sm font-light mb-2">{{ 'technologies.description' | translate }}
      </p>
    </div>
    <button type="button" (click)="toggleTechnologies()" [ngClass]="buttonClasses" class="toggle-btn"
      [attr.aria-expanded]="showTechnologies ? 'true' : 'false'" aria-controls="technologies-section"
      aria-label="Mostrar u ocultar detalles de tecnologías">
      {{ 'technologies.buttonLabel' | translate }}
    </button>
  </div>
</section>